import { Injectable, Injector } from '@angular/core';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { Vars } from '../model/vars';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';
import { ReportRPPM } from './../model/report-rppm';

@Injectable()
export class ReportRPPMService extends BaseReportService<ReportRPPM> {

  public uri = '/api/reportRPPM/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance ReportRPPM');
  }

  buildSentence(entity?: ReportRPPM, event?: LazyLoadEvent): HttpParams {
    return null;
  }

  searchToViewTable(   fiscalYear: any,
    executingUnit: any,
    month: any,
    payrollType: any,
    employeeType: any,
    sign: any,
    payrollConcept?: any,
    costCenter?: any,
    employee?: any,
    object?: Vars
    ): Observable<any> {
      const params = new HttpParams()
        .set('fiscalYearId', fiscalYear)
        .set('euId', executingUnit)
        .set('monthId', month)
        .set('payrollTypeId', payrollType)
        .set('employeeTypeId', employeeType)
        .set('sign', sign)
        .set('payrollConceptId', payrollConcept)
        .set('costCenterId', costCenter)
        .set('employeeId', employee)
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`;
        return this.httpClient.post<any>(url, object, {params}, )
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            return response;
          })
       );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-rppm.service.ts